import styled from 'styled-components';

const DropDownItemName = styled.span`
  font-size: 14px;
`;

export default DropDownItemName;
